import { render } from "./pf_tanchuang.vue?vue&type=template&id=637b2652&scoped=true"
import script from "./pf_tanchuang.vue?vue&type=script&lang=js"
export * from "./pf_tanchuang.vue?vue&type=script&lang=js"

import "./pf_tanchuang.vue?vue&type=style&index=0&id=637b2652&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637b2652"]])

export default __exports__